import React, { Fragment, useState } from "react";
import { arrayOf, func, bool, string, number } from "prop-types";
import { Link } from "react-router-dom";
import { isNil } from "../../helpers/utils";

import { Button, Loading, Validate } from "../../common";

import { Seeking, OwnCarSelector, DrivingLicenseSelector } from "../BasicInfo";
import OnboardImage from "../OnboardImage";
import * as style from "./styles.module.scss";

const constraints = {
  positionSeeking: {
    presence: { allowEmpty: false },
  },
};

const WorkType = (props) => {
  const {
    onBoarding,
    loading,
    selectedTypes,
    selectedHours,
    minSalary,
    salaryFrequency,
    positionSeeking,
    availabilityDay,
    availabilityMonth,
    availabilityYear,
    ownCar,
    driver,
    onChange,
    handleSubmit,
  } = props;

  const prevRoute = "/onboard/cv-upload";
  const [isFormTouched, setFormTouched] = useState(!onBoarding);

  const initialFormInputs = {
    selectedTypes: ["temp"],
    selectedHours: [],
    minSalary: "",
    salaryFrequency: "A",
    positionSeeking: "",
    availabilityDay: "",
    availabilityMonth: "",
    availabilityYear: "",
    ownCar: "",
    driver: "",
  };

  const formInputs = {
    selectedTypes,
    selectedHours,
    minSalary,
    salaryFrequency,
    positionSeeking,
    availabilityDay,
    availabilityMonth,
    availabilityYear,
    ownCar,
    driver,
  };

  (() =>
    !isFormTouched &&
    !(JSON.stringify(formInputs) === JSON.stringify(initialFormInputs)) &&
    setFormTouched(true))();

  return (
    <div className="row h-100">
      <OnboardImage
        title="Looking good"
        subtitle="What type of work are you looking for?"
        imagePath="/images/onboard_work_type.svg"
        className={style.workType__imageBackground}
        imageClassName={style.workType__image}
      ></OnboardImage>

      <div
        className={`h-100 col-sm-12 col-lg-6 mt-1 mt-lg-0 ${style.workType__form}`}
      >
        <div className="row">
          <div className="col-12">
            <Validate constraints={constraints} userInput={{ positionSeeking }}>
              {({ isValid, validation }) => (
                <Seeking
                  onChangeHandler={onChange}
                  positionSeeking={positionSeeking}
                  isValid={isValid}
                  validation={validation}
                />
              )}
            </Validate>
            {onBoarding && (
              <Fragment>
                {" "}
                <DrivingLicenseSelector
                  value={driver}
                  toggleSelected={onChange}
                />
                <OwnCarSelector value={ownCar} toggleSelected={onChange} />
              </Fragment>
            )}
          </div>
        </div>
        <div
          className={`mt-lg-auto my-2 mb-lg-0 ${style.workType__buttonContainer}`}
        >
          {onBoarding && (
            <Link
              to={prevRoute}
              className="btn btn-outline-info text-dark mr-1"
            >
              Back
            </Link>
          )}
          <Validate constraints={constraints} userInput={{ positionSeeking }}>
            {({ isValid }) => (
              <Button
                disabled={
                  !isValid ||
                  isNil(driver) ||
                  driver === "" ||
                  ownCar === "" ||
                  isNil(ownCar)
                }
                classes="btn btn-primary btn-block"
                onClick={handleSubmit}
              >
                {" "}
                {loading ? <Loading /> : `${onBoarding ? "Next" : "Save"}`}
              </Button>
            )}
          </Validate>
        </div>
      </div>
    </div>
  );
};

WorkType.propTypes = {
  onBoarding: bool,
  loading: bool.isRequired,
  selectedTypes: arrayOf(string).isRequired,
  selectedHours: arrayOf(string).isRequired,
  minSalary: number.isRequired,
  salaryFrequency: string.isRequired,
  positionSeeking: string.isRequired,
  availabilityDay: string.isRequired,
  availabilityMonth: string.isRequired,
  availabilityYear: string.isRequired,
  ownCar: bool.isRequired,
  driver: bool.isRequired,
  description: string.isRequired,
  seekingDescription: string.isRequired,
  toggleType: func.isRequired,
  toggleBothTypes: func.isRequired,
  toggleHours: func.isRequired,
  toggleBothHours: func.isRequired,
  onChange: func.isRequired,
  handleSubmit: func.isRequired,
  onboardNextRoute: string.isRequired,
};

export default WorkType;
